import { useState } from 'react';
import { AMLRiskScoringTypes, RiskScoringTypes } from '../types';
import RiskScoringContent from './risk-scoring-content';
import { OrganizationType } from '../../../../hoc/common/types';

const CorporateRiskScoring = ({
  aml,
  monthlyTurnover,
  countries,
  blockCollapsed,
  deliveryChannels,
  products,
  sourcesOfFunds,
  sicCodesDictionaries,
  riskScoreRanges,
}: AMLRiskScoringTypes) => {
  const [expandedRows, setExpandedRows] = useState<string[]>([
    RiskScoringTypes.DELIVERY_CHANNEL,
    RiskScoringTypes.GEOGRAPHICAL_RISK,
    RiskScoringTypes.PRODUCTS,
    RiskScoringTypes.SIC_CODES,
    RiskScoringTypes.DATE_ON_INCORPORATION,
    RiskScoringTypes.MONTHLY_VOLUMES,
  ]);

  const onExpandClick = () => {
    if (expandedRows.length) {
      setExpandedRows([]);
    } else {
      setExpandedRows([
        RiskScoringTypes.DELIVERY_CHANNEL,
        RiskScoringTypes.GEOGRAPHICAL_RISK,
        RiskScoringTypes.PRODUCTS,
        RiskScoringTypes.SIC_CODES,
        RiskScoringTypes.DATE_ON_INCORPORATION,
        RiskScoringTypes.MONTHLY_VOLUMES,
      ]);
    }
  };

  return (
    <RiskScoringContent
      blockCollapsed={blockCollapsed}
      onExpandClick={onExpandClick}
      expandedRows={expandedRows}
      type={OrganizationType.CORPORATE}
      setExpandedRows={setExpandedRows}
      aml={aml}
      countries={countries}
      deliveryChannels={deliveryChannels}
      products={products}
      sourcesOfFunds={sourcesOfFunds}
      sicCodesDictionaries={sicCodesDictionaries}
      monthlyTurnover={monthlyTurnover}
      riskScoreRanges={riskScoreRanges}
    />
  );
};

export default CorporateRiskScoring;
